import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import $ from 'jquery';
import { getImgPath } from '../store/JSTool';
import { useSelector, useDispatch } from 'react-redux';


export default function LogoAniView() {

    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {
        setTimeout(() => {
            $("#logo_ani_div").fadeOut("slow");
        }, 2100);
    }, []);

    return (
        <Stack
            id='logo_ani_div'
            sx={{
                width: 1,
                height: 1,
                bgcolor: 'white',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                zIndex: 1000,
                overflow: 'hidden',
            }}>

            <Stack sx={{
                width: settingData.isMobile ? 1 : '900px',
                height: settingData.isMobile ? '200px' :'417px',
                position: 'relative',
                overflow: 'hidden',
            }}>
                <Box
                    id='mv_first_div'
                    component={'img'}
                    src={getImgPath('logo_mv_first.png')}
                    sx={{
                        width: 1,
                        height: 1,
                        objectFit: 'contain',
                        position: 'absolute',
                        zIndex: 1,
                    }} />

                <Box
                    component={'video'}
                    autoPlay={true}
                    muted={true}
                    playsInline={true}
                    disablePictureInPicture={true}
                    src={getImgPath('logo_mv.mp4')}
                    sx={{
                        width: 1,
                        height: 1,
                        objectFit: 'contain',
                        position: 'absolute',
                        zIndex: 2,
                    }} />

            </Stack>

        </Stack>
    );
}